import React from 'react';
import { IAuditoriaCreditoEstagnadoResultado } from '../interfaces/IAuditoriaCreditoEstagnado';

interface Props {
  resultado: IAuditoriaCreditoEstagnadoResultado;
  onVerDetalhe: () => void;
}

const formatCurrency = (value?: number) =>
  (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const AuditoriaResumoCreditoEstagnado: React.FC<Props> = ({ resultado, onVerDetalhe }) => {
  const bordaCor =
    resultado.status === 'ERRO'    ? '#f64e60' :
    resultado.status === 'ALERTA'  ? '#ffa800' :
    resultado.status === 'AVISO'   ? '#ffa800' :
                                     '#1bc5bd';

  const badgeCor =
    resultado.status === 'ERRO'    ? 'danger' :
    resultado.status === 'ALERTA'  ? 'warning' :
    resultado.status === 'AVISO'   ? 'warning' :
                                     'success';

  return (
    <div
      className='card card-custom card-stretch mb-5'
      style={{ borderLeft: `4px solid ${bordaCor}` }}
    >
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            Créditos Fiscais Estagnados
          </span>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Tributos a Recuperar (1.01.02.03) e a Compensar (1.01.02.04)
          </span>
        </h3>
        <div className='card-toolbar'>
          <span className={`badge badge-light-${badgeCor} fs-7 fw-bold`}>
            {resultado.status}
          </span>
        </div>
      </div>

      <div className='card-body pt-3'>
        <div className='row mb-4'>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{resultado.totalErros}</div>
            <div className='text-muted fs-7'>Erros (≥ 11m)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAlertas}</div>
            <div className='text-muted fs-7'>Alertas (6–10m)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-warning'>{resultado.totalAvisos}</div>
            <div className='text-muted fs-7'>Avisos (3–5m)</div>
          </div>
          <div className='col-3 text-center'>
            <div className='fs-2 fw-bolder text-danger'>{formatCurrency(resultado.perdaSelicTotal)}</div>
            <div className='text-muted fs-7'>Perda SELIC Total</div>
          </div>
        </div>

        {resultado.status !== 'CONCILIADO' && resultado.itens.length > 0 && (
          <div className='table-responsive mb-4'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Conta</th>
                  <th>Saldo</th>
                  <th>Inércia</th>
                  <th>Perda SELIC</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {resultado.itens.slice(0, 5).map((item, i) => (
                  <tr key={i}>
                    <td>
                      <span className='fw-bold'>{item.descricaoConta}</span>
                      <br />
                      <span className='text-muted fs-8'>{item.contaReferencial}</span>
                    </td>
                    <td className='fw-bold'>{formatCurrency(item.saldoAtual)}</td>
                    <td>
                      <span className={`fw-bold ${item.status === 'ERRO' ? 'text-danger' : 'text-warning'}`}>
                        {item.mesesInercia} mês(es)
                      </span>
                    </td>
                    <td className='text-danger fw-bold'>{formatCurrency(item.perdaSelic)}</td>
                    <td>
                      <span className={`badge badge-light-${item.status === 'ERRO' ? 'danger' : 'warning'}`}>
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {resultado.status === 'CONCILIADO' && (
          <div className='text-success fw-bold fs-6'>
            ✓ Nenhum crédito fiscal com inércia superior a 3 meses identificado.
          </div>
        )}

        <button className='btn btn-sm btn-light-primary mt-2' onClick={onVerDetalhe}>
          Ver detalhes
        </button>
      </div>
    </div>
  );
};

export default AuditoriaResumoCreditoEstagnado;
